import React, { Component, Fragment } from 'react';
import { Avatar, Drawer, List, Tooltip } from 'antd';
import { PriceFormat } from '../scripts/helpers';
import { Constants } from '../scripts/settings';
import Resources from '../scripts/resources';

class ProductView extends Component {
    render() {
        const { data, onClose, visible } = this.props;

        return (
            <Drawer visible={visible} closable={false} onClose={onClose} placement="left" width="600">
                <List>
                    <List.Item>
                        <List.Item.Meta title={Resources.title} description={data.name} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.barcode} description={data.code || '-'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.category} description={data.category ? `${data.category.name}${data.sub_category ? ` / ${data.sub_category.name}` : ''}` : '-'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.price} description={`${PriceFormat(data.priceOne)}/${PriceFormat(data.priceTwo)}/${PriceFormat(data.priceThree)}`} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.status} description={PriceFormat(!!parseInt(data.status) ? Resources.active : Resources.inactive)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title="VIP" description={PriceFormat(!!parseInt(data.isVip) ? Resources.active : Resources.inactive)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.inventory} description={data.inventory} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.safeFloor} description={data.safeFloor} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.description} description={data.description || '-'} />
                    </List.Item>
                    {data.tag && !!data.tag.length && <List.Item>
                        <List.Item.Meta title={Resources.tags} description={<Fragment>{data.tag.map(o => <div key={o.id}>{o.name}</div>)}</Fragment>} />
                    </List.Item>}
                    {data.gallery && !!data.gallery.length && <List.Item>
                        <List.Item.Meta title={Resources.images} description={<Fragment>{data.gallery.map(o => <Tooltip key={o.id} title={<Avatar src={`${Constants.imagePathProduct}${o.image}`} shape="square" size={200} />}><Avatar src={`${Constants.imagePathProduct}${o.image}`} shape="square" size={60} style={{ marginBottom: 10, marginLeft: 10 }} /></Tooltip>)}</Fragment>} />
                    </List.Item>}
                </List>
            </Drawer>
        );
    }
};

export default ProductView;